/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { useEnsureTipTapContent } from "cms/rich-text/simplicity-composer-tiptap/use-ensure-tiptap-content";
import { Logger } from "cms/utils/log/logger";

export function useConvertQuillToTiptap () {
    
    // FIXME: using this context limits this to working in composer.
    //    This likely is OK, except that in 'this code' is not located in composer to make that clear
    const { component, update } = useUpdateComponent();
    const { richtext } = component;
    const { isQuill, tiptapContent: _tiptapContent } = useEnsureTipTapContent(richtext);

    // keep the unmodified (unless it's Quill) state of the full component for later
    const original = structuredClone(component);

    // modify the cloned component to match the new component type
    let tiptapContent = _tiptapContent;
    if (isQuill) {
        original.type = "component.rich-text";
        original.richtext = _tiptapContent;
    } else {
        tiptapContent = structuredClone(richtext);
    }

    // fire only on mount
    useEffect(
        () => {
            if (isQuill) {
                Logger.debug("useConvertQuillToTipTap -> saving converted component to api");

                // the actual component is the base this time
                update("type", original.type);
                update("richtext", original.richtext);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []
    );

    return {
        tiptapContent,
        original,
    };
}
